export default __webpack_public_path__ + "static/media/icon_radiobutton_off.99928e16.svg";